import { HttpMethod } from "../../../../../../shared/frontend/api/httpStatus";

/** HTTP-Methoden, die der API-Client und seine Richtlinien unterscheiden; GET/HEAD aus Shared. */
export const HTTP_METHOD_GET = HttpMethod.Get;
export const HTTP_METHOD_HEAD = HttpMethod.Head;
export const HTTP_METHOD_OPTIONS = "OPTIONS";
export const HTTP_METHOD_POST = "POST";
